import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { CustomCard } from '../../../../Components';
import { useSelectedTheme, useTranslate } from '../../../../Hooks';

import {
  AEDIcon,
  BankNote1Icon,
  ClockFastForward,
  UserOneIcon,
  WalletIcon03,
} from '../../../../assets/icons';

import useStyles from './styles';
function WalletTransactionsSummaryCards({ KPIsData }) {
  const { translate } = useTranslate('WalletTransactionsView');
  const styles = useStyles();

  const {
    theme: { palette },
  } = useSelectedTheme();

  const formatNumber = (num, { withK = false } = {}) => {
    console.log('num: ', num);
    if (withK && num >= 1000) {
      return (
        (num / 1000).toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }) + 'k'
      );
    }
    return num?.toLocaleString();
  };
  return (
    <Box className={styles.cardsWrapper}>
      <CustomCard
        classes={styles.cardStyle}
        boxShadow='xs'
        borderRadius='xl'
        borderColor='secondary'
      >
        <Typography
          component='p'
          variant='body1'
          className={styles.title}
        >
          {translate('minutes-used')}
        </Typography>
        <Box className={styles.infoContainer}>
          <Typography
            variant='h2'
            component='h2'
            className={styles.subTitle}
          >
            {formatNumber(KPIsData?.minutesUsed)}
          </Typography>
          <Box className={styles.iconContainer}>
            <ClockFastForward
              width='24'
              height='24'
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
      <CustomCard
        classes={styles.cardStyle}
        boxShadow='xs'
        borderRadius='xl'
        borderColor='secondary'
      >
        <Typography
          component='p'
          variant='body1'
          className={styles.title}
        >
          {translate('balance-charged')}
        </Typography>
        <Box className={styles.infoContainer}>
          <span style={{ display: 'inline-flex', alignItems: 'flex-start' }}>
            <Typography
              variant='h2'
              component='h2'
              className={styles.subTitle}
            >
              {formatNumber(KPIsData?.balanceCharged, { withK: true })}
            </Typography>
            <AEDIcon
              width='20'
              height='20'
              fill={palette.text.tertiary}
              style={{ verticalAlign: 'super', marginLeft: 4 }}
            />
          </span>
          <Box className={styles.iconContainer}>
            <BankNote1Icon
              width='24'
              height='24'
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
      <CustomCard
        classes={styles.cardStyle}
        boxShadow='xs'
        borderRadius='xl'
        borderColor='secondary'
      >
        <Typography
          component='p'
          variant='body1'
          className={styles.title}
        >
          {translate('remaining-balance')}
        </Typography>
        <Box className={styles.infoContainer}>
          <Typography
            variant='h2'
            component='h2'
            className={styles.subTitle}
          >
            {formatNumber(KPIsData?.remainingBalance)}
          </Typography>
          <Box className={styles.iconContainer}>
            <WalletIcon03
              width='24'
              height='24'
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
      <CustomCard
        classes={styles.cardStyle}
        boxShadow='xs'
        borderRadius='xl'
        borderColor='secondary'
      >
        <Typography
          component='p'
          variant='body1'
          className={styles.title}
        >
          {translate('active-agents')}
        </Typography>
        <Box className={styles.infoContainer}>
          <Typography
            variant='h2'
            component='h2'
            className={styles.subTitle}
          >
            {KPIsData?.activeAgents}
          </Typography>
          <Box className={styles.iconContainer}>
            <UserOneIcon
              width='24'
              height='24'
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
    </Box>
  );
}

export default WalletTransactionsSummaryCards;
